<div id="content">
  <div class="page-title">
    <a mat-button [routerLink]="['/employees', 'rrhh', 'job-vacancies', job_vacancy_id]">
      <mat-icon>arrow_back</mat-icon>
      @if (job_vacancy(); as vacancy) {
        {{ vacancy.title }}
      } @else {
        Vacante
      }
    </a>

    @if (job_candidate(); as candidate) {
      <h1>
        {{ candidate.full_name }}
        @if (is_discarded()) {
          <span class="discarded-badge">Descartado</span>
        }
      </h1>
      <div class="title-actions">
        @if (!is_discarded()) {
          <button mat-stroked-button type="button" color="warn" class="discard-candidate-button" (click)="discardCandidate()">
            Descartar
          </button>
          <button
            mat-flat-button
            color="accent"
            type="button"
            [disabled]="loading() || saving() || candidate_form.invalid"
            (click)="saveCandidate()"
          >
            Guardar
          </button>
        }
      </div>
    } @else {
      <h1>Candidato</h1>
    }
  </div>

  @if (loading()) {
    <p>Cargando...</p>
  } @else {
    @if (job_candidate()) {
      <section class="card section">
        <h2>Datos</h2>
        <form class="section-body" [formGroup]="candidate_form">
          <div class="form-grid">
            <mat-form-field>
              <mat-label>Nombre completo</mat-label>
              <input matInput formControlName="full_name" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>Email</mat-label>
              <input matInput type="email" formControlName="email" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>Teléfono</mat-label>
              <input matInput formControlName="phone" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>LinkedIn</mat-label>
              <input matInput formControlName="linkedin_url" />
            </mat-form-field>

            <mat-form-field>
              <mat-label>Fase actual</mat-label>
              <mat-select formControlName="job_vacancy_phase_id">
                @for (phase of sorted_phases(); track phase.id) {
                  <mat-option [value]="phase.id">{{ phase.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field class="form-grid-span-all">
              <mat-label>Notas</mat-label>
              <textarea matInput formControlName="notes" rows="4"></textarea>
            </mat-form-field>
          </div>
        </form>
      </section>

      <section class="card section">
        <h2>Historial de fases</h2>
        <div class="section-body">
          <app-job-vacancy-candidate-phase-trackline [phases]="sorted_phases()" [job_candidate]="job_candidate()" />
        </div>
      </section>

      <section class="card section">
        <h2>Actas y reuniones</h2>
        <div class="section-body">
          <app-job-vacancy-candidate-meeting-records-list
            [job_vacancy_id]="job_vacancy_id"
            [job_candidate_id]="job_candidate_id"
            [is_discarded]="is_discarded()"
          />
        </div>
      </section>
    }
  }
</div>
